export default __webpack_public_path__ + "static/kpi-jumbotron-40ef4957a6c4158c24aec46d6b9303a6.jpg";